import {memo} from "react";
import Label from "./Label";
import Input from "./Input";
import Textarea from "./Textarea";
import Checkbox from "./Checkbox";
import Select from "./Select";
import Editor from "./CodeEditor";
import Alert from "../alert/Alert";
import Radio from "./Radio";

const Field = (options) => {

    let groupClass = 'Group'
    let wrapperClass = ''


    if (options && options.wrapper) {
        wrapperClass += ` ${options.wrapper}`
    }

    if (options && options.groupClass) {
        groupClass += ` ${options.groupClass}`
    }


    const RenderSwitch = (params) => {

        switch (params.type) {

            case 'select':
                return <Select {...params} />

            case 'checkbox':
                return <Checkbox {...params} />

            case 'radio':
                return <Radio {...params} />

            case 'textarea':
                return <Textarea {...params} />

            case 'editor':
                return <Editor {...params} />

            case 'query':
                return '<span>Query Builder</span>'


            case 'component':
                return params.component

            case null:
                return null

            default:
                return <Input {...params} />

        }
    }


    const AlertOptions = {
        className: 'alert-primary',
        message  : options.alert
    }


    return (
        <div className={groupClass}>
            {options.hasPreview && <div className="row">
                <div className="input-preview">
                    <img alt="preview" src={options.value}/>
                </div>
                <div className="input-preview-field">
                    <div className={wrapperClass}>
                        {options.label != null && options.inline != true && <Label {...options} />}
                        <RenderSwitch {...options} />
                    </div>
                </div>
            </div>}

            {!options.hasPreview &&
                <div className={wrapperClass}>
                    {options.alert && <Alert {...AlertOptions} />}
                    {options.label != null && options.inline != true && <Label {...options} />}
                    {options.beforeField && <div className="before-field">{options.beforeField}</div>}
                    <RenderSwitch {...options} />
                    {options.afterField && <div className="after-field">{options.afterField}</div>}
                </div>}
        </div>
    )
}

export default memo(Field);